import FullscreenIcon from "@mui/icons-material/Fullscreen";
import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeUp from "@mui/icons-material/VolumeUp";
import { Box, IconButton, Slider, Stack, Typography } from "@mui/material";
import ReactPlayer from "react-player";

export function VideoPlayer({
  playerRef,
  url,
  volume,
  setVolume,
  onEnded,
  handleFullscreen,
  currentVideo,
}) {
  return (
    <>
      <ReactPlayer
        ref={playerRef}
        url={url}
        volume={volume / 100}
        playing
        style={{
          maxWidth: "90vw",
        }}
        controls
        onEnded={onEnded}
      />
      <Box display="flex" alignItems="center">
        <Box sx={{ width: 200 }} mr={4}>
          <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
            <IconButton onClick={() => setVolume(volume - 10)} disabled={volume <= 0}>
              <VolumeDown />
            </IconButton>
            <Slider aria-label="Volume" value={volume} onChange={(_, v) => setVolume(v)} />
            <IconButton onClick={() => setVolume(volume + 10)} disabled={volume >= 100}>
              <VolumeUp />
            </IconButton>
          </Stack>
        </Box>
        <IconButton onClick={handleFullscreen} title="Tela cheia">
          <FullscreenIcon />
        </IconButton>
      </Box>
      <Typography variant="h1" fontSize="20px" fontWeight="bold" mt={3}>
        {currentVideo?.title}
      </Typography>
      <Typography fontSize="14px" mt={3} sx={{ overflowWrap: "break-word" }}>
        {currentVideo?.description}
      </Typography>
    </>
  );
}
